<template>
  <container fluid class="main-content-container px-4 full-height">
    <!-- Pricing Section -->
    <section class="pricing bottom-spacer" id="pricing">
      <div class="container">
        <div class="row">
          <div class="col mt-4">
            <h2 class="section-title text-center mt-4">Simple Pricing</h2>
            <div class="plans">
              <div class="plan plan-sm">
                <header>
                  <h2 class="plan-title">free</h2>
                </header>
                <p class="plan-text">Use on 30 mails per month</p>
                <p class="plan-text">Basic Support</p>
                <router-link class="btn btn-free btn-plan text-capitalize" to="/">Start Free</router-link>
              </div>
              <div class="plan plan-lg">
                <header>
                  <h2 class="plan-title">pro</h2>
                </header>
                <div v-if="planYear === false" class="plan-price-pro">${{monthlyPlan}}</div>
                <div class="subtext">UNLIMITED FOREVER</div>
                <p class="plan-text"></p>
                <p class="plan-text">
                  <svg width="14" height="14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M10.742.658c.45-.698 1.332-.87 1.98-.375.646.491.806 1.451.355 2.153L6.53 12.608a1.56 1.56 0 0 1-.079.111c-.46.662-1.32.815-1.957.33L.612 10.092C-.035 9.6-.196 8.636.26 7.93c.45-.701 1.337-.873 1.988-.378L4.97 9.626 10.742.658z"
                      fill="#007bff"
                    />
                  </svg> Unlimited mails per month
                </p>
                <!-- <p class="plan-text">
                  <svg width="14" height="14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M10.742.658c.45-.698 1.332-.87 1.98-.375.646.491.806 1.451.355 2.153L6.53 12.608a1.56 1.56 0 0 1-.079.111c-.46.662-1.32.815-1.957.33L.612 10.092C-.035 9.6-.196 8.636.26 7.93c.45-.701 1.337-.873 1.988-.378L4.97 9.626 10.742.658z"
                      fill="#007bff"
                    />
                  </svg> Default mail template
                </p>-->
                <p class="plan-text">
                  <svg width="14" height="14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M10.742.658c.45-.698 1.332-.87 1.98-.375.646.491.806 1.451.355 2.153L6.53 12.608a1.56 1.56 0 0 1-.079.111c-.46.662-1.32.815-1.957.33L.612 10.092C-.035 9.6-.196 8.636.26 7.93c.45-.701 1.337-.873 1.988-.378L4.97 9.626 10.742.658z"
                      fill="#007bff"
                    />
                  </svg> Premium Support
                </p>
                <button
                  class="btn btn-pro btn-plan text-capitalize fs-"
                  @click="googleAuth()"
                >Start Pro</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </container>
</template>

<script>
import firebase from "firebase";

export default {
  data() {
    return {
      planYear: false,
      monthlyPlan: "4.99"
    };
  },
  methods: {
    googleAuth() {
      const provider = new firebase.auth.GoogleAuthProvider();

      firebase
        .auth()
        .signInWithPopup(provider)
        .then(result => {
          this.$router.push({
            name: "checkout",
            params: { uid: result.user.uid }
          });
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
};
</script>

<style lang="css" scoped>
.container {
  user-select: none !important;
}

.full-height {
  min-height: 85vh;
  display: flex;
  flex-direction: column;
}

.plan {
  font-family: "open sans" !important;
}

.btn {
  border: none;
  color: #fff;
  width: 200px;
  max-width: 285px;
  transition: all 0.25s ease-in-out;
  border-radius: 50px;
  color: #fff;
  display: inline-block;
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 2px;
  line-height: 2.5rem;
  text-align: center;
  text-transform: uppercase;
  cursor: pointer;
}

.btn:hover,
btn:focus {
  color: #fff;
  transform: translateY(-5px);
}

.btn-plan {
  position: absolute;
  bottom: -26px;
  left: 0;
  right: 0;
  margin: 0 auto;
}

.btn-pro {
  background-color: #0fd866;
}

.btn-pro:hover,
.btn-pro:focus {
  box-shadow: rgba(15, 216, 102, 0.5) 0 5px 20px;
}

.btn-free {
  background-color: #353535;
}

.btn-free:hover,
.btn-free:focus {
  box-shadow: rgba(34, 34, 34, 0.5) 0 5px 20px;
}

/* Plan Pricing Box Styles */

.plans {
  text-align: center;
  margin-bottom: 6.8rem;
}

.plan-title {
  font-family: "open sans" !important;
  font-size: 3.375rem;
  font-weight: 900;
  line-height: 3.8125rem;
  margin-bottom: 2.625rem;
  margin-top: 0;
  color: #111622;
  text-transform: uppercase;
  text-align: center;
}

.plan-text {
  color: #3d5170 !important;
  font-size: 18px;
  line-height: 25px;
  margin-bottom: 20px;
  margin-top: 0;
  text-align: center;
}

.plan {
  margin-top: 3rem;
  text-align: center;
  display: inline-block;
}

.plan-sm {
  border-radius: 8px;
  box-shadow: rgba(0, 0, 0, 0.14) 0 4px 3.125rem;
  padding: 30px;
  position: relative;
  top: -70px;
  margin-right: -10px;
  width: 300px;
  padding-bottom: 65px;
  background-color: #fff;
}

.plan-lg {
  border-radius: 8px;
  box-shadow: rgba(0, 0, 0, 0.08) 0 4px 3.125rem;
  padding: 4rem 3.125rem;
  position: relative;
  width: 400px;
  background-color: #fff;
}

.plan-price {
  color: #007bff;
  font-size: 22px;
  font-weight: 600;
  line-height: 25px;
  margin: 0 0 35px;
  text-align: center;
}

.plan-price-pro {
  margin: 0 0 10px;
  color: #007bff;
  font-size: 22px;
  font-weight: 600;
  line-height: 25px;
  text-align: center;
}

.section {
  flex: 1;
}

.section-title {
  color: #fff !important;
  text-align: center;
  font-size: 4.0625rem;
  font-weight: 600;
  line-height: 4.1rem;
  margin-bottom: 2.5rem;
  font-family: "open sans", -apple-system, BlinkMacSystemFont, sans-serif !important;
}

.pricing-switch {
  -webkit-box-pack: center;
  display: flex;
  font-size: 22px;
  font-weight: 600;
  justify-content: center;
  line-height: 25px;
}

.pricing-switch-yearly {
  -webkit-box-align: start;
  -webkit-box-direction: normal;
  -webkit-box-orient: vertical;
  align-items: flex-start;
  display: flex;
  flex-direction: column;
}

.pricing-switch-monthly {
  color: #fff;
  min-width: 81.88px;
  font-size: 22px;
  font-weight: 600;
  text-align: right;
  margin-right: 14px;
}

.pricing-subtext {
  color: #fff;
  font-size: 16px;
  font-weight: 400;
}

.subtext {
  font-size: 16px;
  color: #787878;
}

.pricing-button {
  position: absolute;
  bottom: -30px;
  background-color: #007bff;
}

.pricing-button-small {
  position: absolute;
  bottom: -30px;
  width: 200px;
  background-color: #222;
}

@media (max-width: 767px) {
  .plan {
    margin: 40px auto 0px !important;
    width: 100% !important;
    display: block;
    position: relative;
    right: 0;
    padding: 3.125rem !important;
  }
}

@media (max-width: 767px) {
  .section-title {
    transition: all 0.4s ease-in-out;
    font-family: "open sans", -apple-system, BlinkMacSystemFont, sans-serif !important;
    margin-bottom: 120px;
  }

  .section-title {
    font-size: 45px !important;
    line-height: 45px;
    text-align: center !important;
  }
}
</style>